module.exports = __webpack_public_path__ + "media/images/user-4e8cf0d9b3a2dd6c0865dcf4a52a055d.png";